const signInRequest = async (idToken, populateOptions={}) => {
    // Make the POST request
    const response = await fetch('https://bluejims.com:5005/user/sign', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ User logged into our services');
        // You can parse the response if the server sends back any data
        const responseData = await response.json();
        console.log('Server response:', responseData);
        // TODO: navigate to dashboard or store user info
        return responseData.user
    } else {
        console.error('❌ Failed to send user data to netofcomputers.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}

export default signInRequest;